import { render, staticRenderFns } from "./CreateBroadcast.vue?vue&type=template&id=72f7e74d&scoped=true&"
import script from "./CreateBroadcast.vue?vue&type=script&lang=ts&"
export * from "./CreateBroadcast.vue?vue&type=script&lang=ts&"
import style0 from "./CreateBroadcast.vue?vue&type=style&index=0&id=72f7e74d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f7e74d",
  null
  
)

export default component.exports